import { useCallback } from 'react'

import { useFileUploadContext } from './useFileUploadContext'
import { useFileUploadItemContext } from './useFileUploadItemContext'

export function useFileUploadItemRemoveButtonState() {
    const { dispatch } = useFileUploadContext()
    const { fileState } = useFileUploadItemContext()

    const onClick = useCallback(() => {
        if (!fileState) return

        dispatch({ type: 'REMOVE_FILE', file: fileState.file })
    }, [dispatch, fileState])

    return {
        onClick,
    }
}
